module.exports = __webpack_public_path__ + "img/kc.441bc99e.png";